import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { INumber } from '@leedpulse-monorepo/interfaces';

export interface ImportNumberToElevenLabsPayload {
  sender: string;
  group_id: string;
  label: string;
  agentId: string;
}

async function importNumberToElevenLabs(
  payload: ImportNumberToElevenLabsPayload,
  auth: Authentication | null
): Promise<INumber['ai_receptionist']> {
  try {
    if (!auth) {
      throw new ImportNumberToElevenLabsFailure(
        'Vous devez être connecté pour effectuer cette action.',
        'unauthorized'
      );
    }

    const json = await HttpClient.post('/elevenlabs/phone-numbers/import', payload, auth.token);

    return json.data.ai_receptionist;
  } catch (e) {
    if (e instanceof ImportNumberToElevenLabsFailure) throw e;
    console.log('error: ', e);
    throw new ImportNumberToElevenLabsFailure();
  }
}

export class ImportNumberToElevenLabsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default importNumberToElevenLabs;
